import { Box, Chip, Typography } from "@mui/material";

import AllLocationsEventsFilterDropdownContainer from "../../../../common/components/locations/recent-events/AllLocationsEventsFilterDropdownContainer";
import { useAuthenticatedUser } from "../../../../common/hooks/useAuthenticatedUser";
import { AutocompleteOptionType } from "../../../../common/models/autocomplete";
import { RoleEnum } from "../../../../common/models/enums";
import {
  selectedDataHubLocationTagVariable,
  selectedDataHubLocationVariable,
} from "../dataHub.variable";
import RecentEventsServerTableContainer from "../models/recentEvents/RecentEventsServerTableContainer";

const RecentGridItem = (): JSX.Element => {
  const { role } = useAuthenticatedUser();

  const handleLocationChange = (
    locationValue: AutocompleteOptionType
  ): void => {
    selectedDataHubLocationVariable(locationValue);
  };

  const handleTagChange = (
    tagLocations: AutocompleteOptionType[] | null
  ): void => {
    selectedDataHubLocationTagVariable(tagLocations);
  };

  const hasEnhancedCapabilities = ![
    RoleEnum.CUSTOMER_OPERATOR_FOREMAN,
    RoleEnum.OPERATOR_READ_ONLY,
  ].includes(role);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "1em",
          padding: "1em",
        }}
      >
        <Typography variant="h3">Recent activities</Typography>
        <Box
          sx={{
            marginLeft: "auto",
            minWidth: "288px",
            display: "flex",
            alignItems: "center",
            gap: "1em",
          }}
        >
          <AllLocationsEventsFilterDropdownContainer
            enhancedCapabilities={hasEnhancedCapabilities}
            setLocation={handleLocationChange}
            setTagLocations={handleTagChange}
            ignoreDefaultValue
          />
        </Box>
      </Box>

      <Box px="1em" pb="0.5em">
        <Chip label="Showing activity from the past two days" size="small" />
      </Box>

      <RecentEventsServerTableContainer />
    </>
  );
};

export default RecentGridItem;
